import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useInView } from 'react-intersection-observer';

import ScrollButton from '../ScrollButton';
import { CDN_URL } from '../../constants';
import { ArrowDownCircle, ArrowRightCircle } from '../Icons';
import * as Utils from '../../utils';

const ArticleCover = ({
  handleOpen,
  has_featuring: hasFeaturing,
  has_subheader: hasSubheader,
  image,
  isActive,
  items,
  nextArticle,
  setArticlesInitialSlide,
  title,
}) => {
  hasFeaturing = typeof hasFeaturing === 'boolean' ? hasFeaturing : items?.length > 1;
  const [coverRef, isCoverInView] = useInView({ threshold: 0.7, triggerOnce: true });
  const subtitle = items?.[0]?.title || '';
  const category = items?.[0]?.category || '';
  hasSubheader = typeof hasSubheader === 'boolean' ? hasSubheader : !hasFeaturing && subtitle;
  const handleNextSection = () => {
    if (!nextArticle?.title) {
      return;
    }

    Utils.scroll(Utils.slugify(nextArticle?.title));
  };
  const handleFeaturedItemClick = (e, index) => {
    e?.preventDefault();
    setArticlesInitialSlide(index);
  };

  return (
    <div
      className={classnames(
        'article-cover',
        { 'article-cover--active': isActive },
        { 'article-cover--with-subheader': hasSubheader },
        { 'article-cover--slided-up': isCoverInView },
      )}
      ref={coverRef}
    >
      {image && (
        <div className='article-cover__bg'>
          <div className='article-cover__sticky'>
            <div
              className='article-cover__image'
              style={{ backgroundImage: `url(${CDN_URL}${image})` }}
            />
          </div>
        </div>
      )}
      <div className='container'>
        <div className='row'>
          <div className='col'>
            <div className='article-cover__container'>
              <div className='article-cover__next'>Next up</div>
              {title && (
                <div className='article-cover__title' dangerouslySetInnerHTML={{ __html: title }} />
              )}
              {hasSubheader && (
                <div className='article-cover__subheader'>
                  <div
                    className='article-cover__subheader-title'
                    dangerouslySetInnerHTML={{ __html: subtitle }}
                  />
                  {category && <div className='article-cover__subheader-category'>{category}</div>}
                </div>
              )}
              {hasFeaturing && (
                <div className='article-cover__cta'>
                  <ScrollButton onClick={handleNextSection} isHorizontal />
                </div>
              )}
              {hasFeaturing && (
                <div className='article-cover__nav'>
                  <div className='article-cover__nav-title'>Featuring</div>
                  <ul className='article-cover__list'>
                    {items.map((item, index) => {
                      const clickHandler = item.onClick || handleFeaturedItemClick;

                      return (
                        <li
                          className='article-cover__list-item'
                          key={`articles-cover__list-item-${index}`}
                        >
                          <a
                            className='article-cover__list-item-link'
                            href={`#${Utils.slugify(item?.title)}`}
                            onClick={(e) => clickHandler(e, index)}
                          >
                            <ArrowRightCircle className='article-cover__list-item-icon' />{' '}
                            <span dangerouslySetInnerHTML={{ __html: item?.title }} />
                          </a>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              )}
              <div className='article-cover__controls'>
                <ul className='article-cover__controls-list'>
                  <li className='article-cover__controls-list-item'>
                    <button
                      className='article-cover__controls-cta article-cover__controls-cta--next'
                      onClick={handleNextSection}
                    >
                      <ArrowDownCircle className='article-cover__controls-cta-icon' />
                      <span className='article-cover__controls-cta-title'>Next Section</span>
                    </button>
                  </li>
                  <li className='article-cover__controls-list-item'>
                    <button
                      className='article-cover__controls-cta article-cover__controls-cta--open'
                      onClick={handleOpen}
                    >
                      <ArrowRightCircle className='article-cover__controls-cta-icon' />
                      <span className='article-cover__controls-cta-title'>Open</span>
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ArticleCover.propTypes = {
  handleOpen: PropTypes.func,
  has_featuring: PropTypes.bool,
  has_subheader: PropTypes.bool,
  image: PropTypes.string,
  isActive: PropTypes.bool,
  items: PropTypes.array,
  nextArticle: PropTypes.object,
  setArticlesInitialSlide: PropTypes.func,
  title: PropTypes.string,
};

export default ArticleCover;
